import { useParams, Link } from 'react-router-dom';
import { Result, Button, Card, Typography } from 'antd';
import { CheckCircleOutlined, ShoppingOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

export function OrderConfirmationPage() {
  const { orderId } = useParams<{ orderId: string }>();

  return (
    <div className="order-confirmation-page" style={{ maxWidth: 600, margin: '0 auto' }}>
      <Result
        status="success"
        icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
        title="Order Placed Successfully!"
        subTitle={`Your order reference is: ${orderId}`}
        extra={[
          <Link to="/" key="shop">
            <Button type="primary" icon={<ShoppingOutlined />}>
              Continue Shopping
            </Button>
          </Link>,
        ]}
      />

      <Card>
        <Title level={4}>What happens next?</Title>
        <Paragraph>
          <Text strong>1. Order Confirmation</Text>
          <br />
          You will receive an email confirmation with your order details shortly.
        </Paragraph>
        <Paragraph>
          <Text strong>2. Order Processing</Text>
          <br />
          Our team will process your order and prepare it for shipping.
        </Paragraph>
        <Paragraph>
          <Text strong>3. Shipping</Text>
          <br />
          Once shipped, you will receive tracking information via email.
        </Paragraph>
        <Paragraph>
          <Text strong>4. Delivery</Text>
          <br />
          Your order will be delivered to the address you provided.
        </Paragraph>
      </Card>
    </div>
  );
}

export default OrderConfirmationPage;
